import { all, fork } from 'redux-saga/effects'

import errorSaga from './errorSaga'
import eventsSaga from './eventsSaga'
import pageviewSaga from './pageviewSaga'
import trackSaga from './trackSaga'

export function* analyticsSaga() {
  yield all([fork(errorSaga), fork(eventsSaga), fork(pageviewSaga), fork(trackSaga)])
}
